import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const tenantsGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: "tenant.TenantFileRefNo",
    field: "TenantFileRefNo",
    width: 300
  }, {
    title: "tenant.LeaseName",
    field: "LeaseName",
    width: 300
  }, {
    title: "tenant.LeaseType",
    field: "LeaseType",
    width: 300
  }, {
    title: "tenant.UnitDescription",
    field: "UnitDescription",
    width: 300
  }, {
    title: "tenant.Region",
    field: "Region",
    width: 300
  }, {
    title: "tenant.Sector",
    field: "Sector",
    width: 300
  }, {
    title: "tenant.PrimaryUse",
    field: "PrimaryUse",
    width: 300
  }, {
    title: "tenant.Covenant",
    field: "Covenant",
    width: 300
    
  }, {
    title: "tenant.Status",
    field: "Status",
    width: 300
  }, {
    title: "tenant.TenantUse",
    field: "TenantUse",
    width: 300
  },
  {
    title: "tenant.DeemedRent",
    field: "DeemedRent",
    type: "currency",
    width: 150
  }, {
    title: "tenant.GroundRent",
    field: "GroundRent",
    type: "currency",
    width: 150
  }, {
    title: "tenant.CostDeductions",
    field: "CostDeductions",
    type: "number",
    width: 150
  }, {
    title: "tenant.RentalValue",
    field: "RentalValue",
    type: "currency",
    width: 150
  }, {
    title: "tenant.ErvRatePerSqft",
    field: "ErvRatePerSqft",
    type: "area",
    width: 150
  }, {
    title: "tenant.RentRatePerSqft",
    field: "RentRatePerSqft",
    type: "area",
    width: 150
  }, {
    title: "tenant.PercentErv",
    field: "PercentErv",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.PercentRent",
    field: "PercentRent",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.AreaSqft",
    field: "AreaSqft",
    type: "area",
    width: 150
  }, {
    title: "tenant.Froth",
    field: "Froth",
    type: "number",
    width: 150
  }, {
    title: "tenant.PercentFroth",
    field: "PercentFroth",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.ErvUplift",
    field: "ErvUplift",
    type: "number",
    width: 150
  }, {
    title: "tenant.PercentErvUpliftPerRent",
    field: "PercentErvUpliftPerRent",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.PercentErvUpliftPerTotalRent",
    field: "PercentErvUpliftPerTotalRent",
    type: "percentage",
    width: 150
  },
  {
    title: "tenant.NextReview",
    field: "NextReview",
    type: "date",
    width: 200
  },
  {
    title: "tenant.LeaseStart",
    field: "LeaseStart",
    type: "date",
    width: 200
  },
  {
    title: "tenant.LeaseExpiry",
    field: "LeaseExpiry",
    type: "date",
    width: 200
  },
  {
    title: "tenant.PeriodToExpiry",
    field: "PeriodToExpiry",
    type: "number",
    width: 150
  },
  {
    title: "tenant.EffectiveBreak",
    field: "EffectiveBreak",
    type: "date",
    width: 200
  }, {
    title: "tenant.BreakType",
    field: "BreakType",
    width: 300
    
  }, {
    title: "tenant.PeriodToBreak",
    field: "PeriodToBreak",
    type: "number",
    width: 150
  },
  {
    title: "tenant.EarliestTermination",
    field: "EarliestTermination",
    type: "date",
    width: 200
  },

  {
    title: "tenant.PeriodToTermination",
    field: "PeriodToTermination",
    type: "number",
    width: 150,
  }, {
    title: "tenant.VoidExpiryByBreak",
    field: "VoidExpiryByBreak",
    type: "number",
    width: 150
  }, {
    title: "tenant.VacantPeriod",
    field: "VacantPeriod",
    type: "number",
    width: 150
  }, {
    title: "tenant.GrossValue",
    field: "GrossValue",
    type: "currency",
    width: 150
  }, {
    title: "tenant.ErvVacancyLoss",
    field: "ErvVacancyLoss",
    type: "number",
    width: 150
  }, {
    title: "tenant.PercentErvVacancyLoss",
    field: "PercentErvVacancyLoss",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.ErvVoidLoss",
    field: "ErvVoidLoss",
    type: "number",
    width: 150
  }, {
    title: "tenant.CapitalisationGroup",
    field: "CapitalisationGroup",
    width: 150
  }, {
    title: "tenant.ValuationMethod",
    field: "ValuationMethod",
    width: 300
  }, {
    title: "tenant.HardcoreYield",
    field: "HardcoreYield",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.ReversionYield",
    field: "ReversionYield",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.FrothYield",
    field: "FrothYield",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.DcfExitYld",
    field: "DcfExitYld",
    type: "percentage",
    width: 150
  }, {
    title: "tenant.RentFreePeriod",
    field: "RentFreePeriod",
    type: "number",
    width: 150
  }, {
    title: "tenant.ContractedRent",
    field: "ContractedRent",
    type: "currency",
    width: 150
  },
  {
    title: "tenant.tenantId",
    field: "oid",
    width: 100
  }
];
